import {PermissionsNode} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Base permission fixtures with no dependencies on other fixture files.
 * This breaks circular dependencies that can occur when fixtures import each other
 * and are used directly in const declarations.
 */
export const FULL_PERMISSIONS_GRAPHQL: PermissionsNode = {
  __typename: 'PermissionsNode',
  admin: false,
  appendable: false,
  archivable: null,
  batchesWritable: null,
  bioentitiesAppendable: null,
  canAccept: null,
  canAddRemoveAdmins: null,
  canAddRemoveEditors: null,
  canAddRemoveViewers: null,
  canCreateEntriesFromDraftTemplates: null,
  canCreateRequest: null,
  canCreateTeams: null,
  canEditBarcodes: null,
  canEditNamesAndAliases: null,
  canEditNamesAndBarcodes: null,
  canEditRestrictedSampleUsers: null,
  canExecuteRequest: null,
  canManageCollaborators: null,
  canManageRoles: null,
  canReassignRlcReviewer: null,
  canReject: null,
  canRestrictSamples: null,
  canRetract: null,
  canSendForReview: null,
  canUnrestrictSamples: null,
  chemicalStructureEditable: null,
  definitionDeletable: null,
  definitionEditable: null,
  definitionListable: null,
  deletable: null,
  locationsCreatable: null,
  movable: null,
  objectsCreatable: null,
  objectsRegisterable: null,
  owner: null,
  polymerFeaturesEditable: null,
  polymerResiduesEditable: null,
  readable: false,
  registryIdsChangeable: null,
  structurePredictionEditable: null,
  subfolderCreatable: null,
  tagsEditable: null,
  unarchivable: null,
  unregisterable: null,
  writable: false,
  canEditStatus: null,
  canEditContainer: null,
  canChangeStudyableAssignment: null,
  canResetMfa: null,
};
